// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"bdbcdfe8","551":"79be48a6","629":"692e373a"}[chunkId] + ".chunk.js";
};